import axios from 'axios';
// @ts-ignore
//import * as SecureStore from "expo-secure-store";

import { endPoints,paymentEndpoints } from "../constant/Environment";
export const BASE_URL =  endPoints.apiBaseUrl; 
export const PAYMENT_BASE_URL =  paymentEndpoints.apiBaseUrl;       

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
      // Authorization: 'Bearer ' + sessionStorage.getItem('caroktajwt')
  }
});
export const axiosPaymnetInstance = axios.create({
  baseURL: PAYMENT_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
      // Authorization: 'Bearer ' + sessionStorage.getItem('caroktajwt')
  }
}); 

export const axiosFormInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  //  Authorization: 'Bearer ' + sessionStorage.getItem('caroktajwt')
  }
});

// Read the session id, stripping the JSON quotes used when it was stored.
// Exported so raw fetch() calls (multipart uploads, which cannot go through
// the axios instances) can attach the same SessonId header.
export const getSessonId = () => {
  const raw = sessionStorage.getItem('session');
  if (!raw) return null;
  try {
    // stored as JSON ("abc"); fall back to plain replace for legacy values
    return JSON.parse(raw);
  } catch (e) {
    return raw.replace(/"/g, '');
  }
};

// Headers for raw fetch() multipart uploads. Deliberately omits Content-Type:
// the browser has to set it so the multipart boundary is generated, and forcing
// application/json here makes the upload unparseable on the server.
export const uploadHeaders = () => {
  const sessonId = getSessonId();
  return sessonId ? { SessonId: sessonId } : {};
};

// Attach SessonId to EVERY outgoing request on every instance.
const attachSessonId = (config) => {
  const sessonId = getSessonId();
  if (sessonId) {
    config.headers = config.headers || {};
    config.headers.SessonId = sessonId;
  }
  return config;
};

[axiosInstance, axiosPaymnetInstance, axiosFormInstance].forEach((instance) => {
  instance.interceptors.request.use(attachSessonId, (error) => Promise.reject(error));
});
